import React, { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faArrowUp, faArrowDown, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import ReportItem from './ReportItem';
import './ReportList.css';
import { ReportAPI } from '../../../Api/ReportAPI';
import { UserContext, ServiceInfo } from '../../../Utilis';

const ReportList = () => {
    const [reports, setReports] = useState([]);
    const [selectedServiceId, setSelectedServiceId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortOrder, setSortOrder] = useState('desc'); // Default 'desc' za najnovije prve (veći Id prvi)
    const [currentPage, setCurrentPage] = useState(1);
    const [reportsPerPage] = useState(30);
    const [reportOpened, setReportOpened] = useState(null);

    useEffect(() => {
        ReportAPI.getReports().then((res) => {
            if (res.data) {
                setReports(res.data.slice().reverse());
            }
        }).catch(console.error);
    }, []);

    const getServiceNameById = (id) => {
        const service = Object.values(ServiceInfo).find(s => s.serviceNumber === id);
        return service ? service.displayName : `Service ${id}`;
    };

    const availableServiceIds = [...new Set(reports.map(r => r.serviceNumber))].filter(n => n !== null);

    const filteredReports = reports.filter(r => 
        r.serviceNumber === selectedServiceId &&
        r.videoName?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedReports = [...filteredReports].sort((a, b) => {
        return sortOrder === 'desc' ? b.Id - a.Id : a.Id - b.Id;
    });

    const indexOfLastReport = currentPage * reportsPerPage;
    const indexOfFirstReport = indexOfLastReport - reportsPerPage;
    const currentReports = sortedReports.slice(indexOfFirstReport, indexOfLastReport);
    const totalPages = Math.ceil(sortedReports.length / reportsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0,0);
    };

    if (!selectedServiceId) {
        return (
            <div className="report-list-container">
                <h1 className="service-selection-title">Select report category</h1>
                <div className="services-grid">
                    {availableServiceIds.map(id => (
                        <div 
                            key={id} 
                            className="service-card" 
                            onClick={() => setSelectedServiceId(id)}
                        >
                            <h2>{getServiceNameById(id)}</h2>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="report-list-container">
            <div className="back-button-container">
                <button 
                    onClick={() => { setSelectedServiceId(null); setCurrentPage(1); }}
                    className="btn-back"
                >
                    <FontAwesomeIcon icon={faArrowLeft} /> Back to all reports
                </button>
                <h2 className="category-header">
                    Category: <span className="category-highlight">{getServiceNameById(selectedServiceId)}</span>
                </h2>
            </div>

            <div className="controls-container">
                <div className="search-container">
                    <div className="search-input-wrapper">
                        <input
                            type="text"
                            placeholder="Search reports..."
                            value={searchTerm}
                            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                            className="search-input"
                        />
                        <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon" />
                    </div>
                </div>
                <div className="sort-container">
                    <p>Sort</p>
                    <div className="sort-buttons">
                        <FontAwesomeIcon 
                            icon={sortOrder === 'desc' ? faArrowDown : faArrowUp} 
                            className="sort-icon" 
                            onClick={() => setSortOrder(sortOrder === 'desc' ? 'asc' : 'desc')}
                        />
                    </div>
                </div>
            </div>

            <div className="reports-list">
                {currentReports.length > 0 ? (
                    currentReports.map((report, index) => (
                        <ReportItem 
                            key={report.Id}
                            report={report}
                            setShowedReport={() => setReportOpened(report.Id)}
                            showReportId={reportOpened}
                        />
                    ))
                ) : (
                    <p className="no-reports-msg">No reports found.</p>
                )}
            </div>

            {totalPages > 1 && (
                <div className="pagination">
                    {Array.from({ length: totalPages }).map((_, index) => (
                        <button
                            key={index}
                            className={index + 1 === currentPage ? "active" : ""}
                            onClick={() => {
                                paginate(index + 1);
                                setReportOpened(null);
                            }}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ReportList;